import { withCtxAkamaiDevice } from '../akamai/akamai-device-middleware.js';
import { withCtxAkamaiEdgescape } from '../akamai/akamai-edgescape-middleware.js';
import { withCtxMiddleware } from './with-ctx-middleware.js';
import { withCtxBatchDispatch } from './with-ctx-batch-dispatch.js';
import { withCtxFetchCompositeJSON } from './with-ctx-fetch-composite-json.js';
import { withCtxCookies } from './with-ctx-cookies.js';
import { withCtxNormalizedQuery } from './with-ctx-normalized-query.js';
import { withCtxIsBot } from './with-ctx-is-bot.js';
import { withCtxMatch } from './with-ctx-match.js';
import { withCtxResponseRedirect } from './with-ctx-response-redirect.js';

async function enhanceNextCtx(ctx, store) {
  // add the store property to the ctx
  ctx.store = store;
  await withCtxMiddleware([
  // add a redirect method to the response
  withCtxResponseRedirect(),
  // parse akamai headers
  withCtxAkamaiDevice(), withCtxAkamaiEdgescape(),
  // add cookie support
  withCtxCookies(),
  // normalize the ctx object
  // provide backwards compatibility with previous bonnet versions
  // handle nextjs 13.4+ ctx issues removing express props form req and res
  withCtxNormalizedQuery(),
  // add ctx.match shim
  withCtxMatch(),
  // add bot detection
  withCtxIsBot(),
  // add batch dispatch functionality by default
  withCtxBatchDispatch(),
  // add fetch composite json functionality by default
  withCtxFetchCompositeJSON()], ctx);
}

export { enhanceNextCtx };
